import getDomainURL from 'utils/api'

export const handleCaptchaPair = () => {
	if( getDomainURL( '' ).indexOf( 'staging' ) > -1 ) {
    return ({
      sitekey: 'FCMPV4GB40A74R69',
      secret: 'A1EVN3S4HJ07MGQESASIVFSO8NUDO1BG64L0DIPDV5H0JUD1HUODPCGETH'
    })
	}

  if( getDomainURL( '' ).indexOf( 'proof-point' ) > -1 ) {
    return ({
      sitekey: 'FCMPV4GB40E62C1N',
      secret: 'A1T8BKRT9NA1GIBA8P87M9T7U9EI62CFLOG9EHCRB8UBHATGEV2OLVB8D9'
    })
	}

  if ( getDomainURL( '' ).indexOf( 'aciso' ) > -1 ) {
    return ({
      sitekey: 'FCMPV4GB41N1NBTN',
      secret: 'A1J2JIMJBFGQAT10VDAMBILJL6PUQCRKBVV13KOKCL78I5KPGFNP4RMGV8'
    })
  }

  return ({
    sitekey: 'FCMPV4GB40A74R69',
    secret: 'A1EVN3S4HJ07MGQESASIVFSO8NUDO1BG64L0DIPDV5H0JUD1HUODPCGETH'
  })
}

export const showCaptchaFeat = () =>  {
  if( getDomainURL( '' ).indexOf( 'staging' ) > -1 ) {
    return true 
  }

  if( getDomainURL( '' ).indexOf( 'proof-point' ) > -1 ) {
    return true
  }
  
  if ( getDomainURL( '' ).indexOf( 'aciso' ) > -1 ) {
    return true
  }

  return false
}